import { createOrganizationTour } from './definitions/createOrganization';
import { organizationDetailTour } from './definitions/organizationDetail';
import { organizationsListTour } from './definitions/organizationsList';
import { createTournamentTour } from './definitions/createTournament';
import { tournamentStructureTour } from './definitions/tournamentStructure';
import { entryFeePrizeTour } from './definitions/entryFeePrize';
import { walletTour } from './definitions/wallet';
import type { TourDefinition, TourId } from './types';
import { TOUR_IDS } from './types';

const tourRegistry: Record<TourId, TourDefinition> = {
  [TOUR_IDS.ORGANIZATIONS_LIST]: organizationsListTour,
  [TOUR_IDS.CREATE_ORGANIZATION]: createOrganizationTour,
  [TOUR_IDS.ORGANIZATION_DETAIL]: organizationDetailTour,
  [TOUR_IDS.CREATE_TOURNAMENT]: createTournamentTour,
  [TOUR_IDS.TOURNAMENT_STRUCTURE]: tournamentStructureTour,
  [TOUR_IDS.ENTRY_FEE_PRIZE]: entryFeePrizeTour,
  [TOUR_IDS.WALLET]: walletTour,
};

export const getTourDefinition = (tourId: TourId): TourDefinition =>
  tourRegistry[tourId];

export const getAllTourDefinitions = (): TourDefinition[] =>
  Object.values(tourRegistry);
